const endpoint = {
  // List of API URL
  MARLIN_URL: process.env.REACT_APP_API_MARLIN,
  FILE_MANAGEMENT_URL: process.env.REACT_APP_API_FILE_MANAGEMENT_URL,
  TRACEABILITY_URL: process.env.REACT_APP_API_TRACEABILITY_URL,
  MASTERDATA_URL: process.env.REACT_APP_API_MASTER_DATA_URL
};

export default endpoint;
